import {list} from '@/domain/pessoa/services'

const search = function () {
  console.log('click window search pessoa...')
  let window = 'windowPessoaSearch'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Buscar Pessoa',
    width: '800',
    height: '600',
    minHeight: '500',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden bg-white',
    props: {
      columns: [
        {label: 'ID', value: 'id'},
        {label: 'Documento', value: (v) => { return v.document ? this.$options.filters.formataCpfCnpj2(v.document) : '' }},
        {label: 'Nome', value: (v) => { return v.name }},
        {label: 'Tipo', value: (v) => { return v.type == '1' ? 'PF' : 'PJ'}}
      ],
      fetchData: (terms, filters, done) => {
        let rowsPerPage = 100
        list(rowsPerPage, filters.page, '&sortBy=id&descending=desc&search=' + terms)
          .then(({data}) => {
            let filteredData = data.result

            done(filteredData, {
              page: filters.page,
              rowsNumber: data.total, // response.totalRows,
              rowsPerPage: rowsPerPage
            })
          })
          .catch((error) => {
            console.error(error)
          })
      }
    }
  }, () => import('@/components/layout/window/WindowSearch.vue'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        selected: (wid, val) => {
          console.log('Selecionado com sucesso: ', val)
          this.findedData = val
          this.model = val
          this.__emit(val)
          this.description = val.id + ' - ' + val.name
          setTimeout(() => {
            this.$refs.input && this.$refs.input.focus()
          }, 200)
        }
      })
      console.log(wid)
    }) // return wid
}

export default search
